{
  "it": {
    "decision": {
      "actions": {
        "add": "Aggiungi",
        "addDocument": "Aggiungi documento",
        "addUnits": "Unità",
        "approve": "Approva",
        "autoCloseAfterApproval": "Chiusura automatica dopo approvazione",
        "autoCloseAfterApprovalInfo": "La decisione si chiude quando una proposta viene approvata",
        "autoCloseAfterDeadline": "Chiusura automatica dopo la scadenza",
        "cancel": "Annulla",
        "changeResponsible": "Cambia responsabile",
        "clickToSetDeadline": "Faccia clic per impostare la scadenza",
        "closeDecision": "Chiudi decisione",
        "confirmChoices": "Conferma opzioni",
        "createProposal": "Crea proposta",
        "create_decisions": "Crea decisione | Crea decisioni",
        "delete": "Elimina",
        "deleteCount": "Sta per eliminare {count} decisione. È sicuro? | Sta per eliminare {count} decisioni. È sicuro?",
        "deleteMultipleDecisions": "Elimina...",
        "delete_cancel": "Annulla",
        "delete_decisions": "Elimina decisione | Elimina decisioni",
        "edit": "Modifica",
        "editBudget": "Modifica budget",
        "editDeadline": "Modifica scadenza",
        "editDecision": "Modifica decisione",
        "editReminders": "Modifica promemoria",
        "goToDecision": "Vai alla decisione",
        "goToProposal": "Vai alla proposta",
        "goToSummary": "Vai al riepilogo",
        "hide": "Annulla pubblicazione",
        "hideInfo": "Nascondi informazioni",
        "noDescription": "Faccia clic per aggiungere una descrizione",
        "openDecision": "Apri decisione",
        "publish": "Pubblica",
        "publishAll": "Per tutti",
        "publishCustomer": "Pubblica per il cliente",
        "publishPartners": "Pubblica per i partner",
        "reject": "Rifiuta",
        "relaunch_decision": "Rilancia decisione",
        "request_changes": "Richiedi modifiche",
        "reset": "Reimposta",
        "save": "Salva",
        "save_and_share_partners": "Salva e condividi con i partner",
        "selectAll": "Seleziona tutte le {total} unità",
        "selectChoices": "Seleziona opzioni",
        "share_proposals": "Condividi proposte",
        "showMoreInfo": "Mostra maggiori informazioni",
        "stopApproving": "Interrompi approvazione",
        "submit": "Salva",
        "tickBoxesDeletion": "Selezioni le caselle dei file che desidera eliminare.",
        "unSelectAll": "Svuota selezione.",
        "unpublishForCustomer": "Annulla pubblicazione per il cliente",
        "unpublishForPartners": "Annulla pubblicazione per il partner della decisione",
        "update": "Aggiorna",
        "upload": "Carica",
        "upload_documents": "Carica documenti",
        "upload_proposals": "Crea proposta"
      },
      "attributes": {
        "amount_gross": "Offerta lorda",
        "amount_net": "Offerta netta",
        "approved_at": "Data di approvazione proposta",
        "approved_proposal_name": "Proposta approvata",
        "bathrooms": "Numero di bagni",
        "bedrooms": "Numero di camere da letto",
        "category": "Categoria",
        "customer_group_name": "Cliente",
        "decision_name": "Decisione",
        "decisions_count": "{count} decisione | {count} decisioni",
        "due_date": "Scadenza",
        "floor": "Piano",
        "negative_surcharges_allowed": "Consenti credito",
        "note_employee": "Nota",
        "price_budget": "Budget",
        "price_budget_extra": "Budget extra",
        "price_budget_info": "Può sempre modificare il budget in seguito",
        "price_budget_info_mup": "Può sempre modificare il budget per unità in seguito",
        "price_margin": "Margine",
        "price_surcharge": "Miglioria",
        "published": "Pubblicata",
        "responsible": "Responsabile",
        "status": "Stato",
        "unit": "Unità",
        "verification_type": "Decisione di approvazione data da",
        "visibility": "Visibilità"
      },
      "edit_actions": {
        "edit_auto_close": "Opzioni di chiusura automatica",
        "edit_close_decision": "Chiudi/apri decisione",
        "edit_deadline": "Imposta scadenza",
        "edit_margin": "Imposta margini",
        "edit_negative_surcharges_allowed": "Consenti credito",
        "edit_not_interested_allowed": "Consenti l'opzione \"Non interessato\"",
        "edit_note_employee": "Modifica nota",
        "edit_price_budget": "Imposta budget",
        "edit_price_budget_extra": "Imposta budget extra",
        "edit_reminders": "Imposta promemoria",
        "edit_responsible": "Imposta responsabile"
      },
      "labels": {
        "accessRights": "Diritti di accesso",
        "activity": "Cronologia",
        "addDecisionNote": "Aggiungi nota",
        "addReminders": "Aggiungi promemoria",
        "allUnits": "Tutte le unità",
        "allUnitsAssigned": "Tutte le unità assegnate",
        "allow_not_interested": "Consenti l'opzione \"Non interessato\"",
        "allow_not_interested_cancel_warning": "Questa decisione è attualmente contrassegnata come \"Non interessato\". Disattivando questa opzione, lo stato \"Non interessato\" verrà annullato.",
        "allow_not_interested_info": "Mostra un'opzione \"Non interessato\" accanto alle proposte",
        "approved": "Approvata",
        "approvedAt": "Approvata il {approved_at}",
        "approvedProposal": "Proposta approvata",
        "askQuestion": "Faccia qui le Sue domande sulla decisione {decision}",
        "assignCustomerToUnit": "Assegna cliente",
        "autoClose": "Chiusura automatica",
        "budgetOverview": "Panoramica budget",
        "budgetSubtitle": "Inserisca qui un budget se si applica a tutte le unità selezionate, oppure aggiunga i budget in seguito",
        "budgetTitle": "Impostazione di un budget",
        "checkbox": "Casella di controllo",
        "clickHereToChange": "Faccia clic qui se desidera modificarli.",
        "close": "Chiudi",
        "closeDecision": "Chiudi decisione",
        "closed": "La decisione è chiusa per questa unità. Il cliente non potrà più approvare una proposta.",
        "closedLabel": "Chiusa",
        "closed_tag": "Decisione chiusa",
        "closed_tooltip_customer": "La decisione è chiusa. Non potrà più approvare una proposta.",
        "countDocuments": "Nessun documento ancora | 1 documento | {count} documenti",
        "countEdit": "Modifica la decisione di {count} unità | Modifica la decisione di {count} unità",
        "countUpload": "Carica documento/i per questa unità | Carica documento/i per {count} unità",
        "created_on": "Decisione creata il {date}",
        "custom_columns_title": "Può aggiungere fino a 10 colonne",
        "customer": "Cliente",
        "customer_status": "Stato del cliente",
        "decided": "Deciso",
        "decision": "Decisione",
        "decisionBreadcrumb": "Decisione {decision_type}",
        "decisionNotPublishedYetFor": "Decisione non ancora pubblicata per",
        "decisionNoteExplainer": "Questa nota è visibile solo al Suo team e ai partner autorizzati a vedere questa decisione",
        "decisionType": "Oggetto della decisione",
        "decisionUnit": "Decisione per l'unità {unit}",
        "decisions": "Decisioni",
        "decisions_all_projects": "Decisioni di tutti i progetti",
        "decisions_breadcrumb": "Decisioni {project}",
        "default": "Predefinito",
        "deleteExplanation": "Tutti i messaggi, i file, le proposte e gli altri dati verranno rimossi definitivamente dalla piattaforma. I clienti e i partner collegati a queste decisioni perderanno tutto l'accesso.",
        "descriptionSubtitle": "Qui può aggiungere ulteriori informazioni per i Suoi clienti",
        "descriptionTitle": "Aggiunga una descrizione per il Suo cliente",
        "documentRequired": "Documento firmato richiesto per l'approvazione",
        "documentUnits": "Cartella unità",
        "documents": "Documenti",
        "dueDate": "Scadenza {date}",
        "due_date_subtitle": "Imposti una data entro cui la decisione deve essere presa",
        "due_date_title": "Scadenza e promemoria",
        "editDecisionNote": "Modifica nota",
        "extra_options": "Impostazioni aggiuntive",
        "false": "No",
        "filter": "Filtro",
        "finalSettings": "Alcune impostazioni facoltative",
        "finalSettingsStep": "Impostazioni finali",
        "financial": "Finanziario",
        "firstThingsfirst": "Prima di tutto, alcune informazioni generali",
        "follow": "Segui",
        "following": "Segue — riceverà notifiche",
        "four": "4",
        "giveNewAmount": "Inserisca il nuovo importo",
        "hideCount": "Annulla la pubblicazione di questa decisione per 1 unità | Annulla la pubblicazione della decisione per {count} unità",
        "hideVisibilitySettings": "Nascondi impostazioni di visibilità",
        "indicate_not_interested": "Indica che il cliente non è interessato a questa decisione",
        "info": "Mostra maggiori informazioni",
        "infoCustomers": "Dettagli cliente",
        "information": "Informazioni",
        "leaveBudgetEmptyInfo": "Lasci vuoto se non desidera utilizzare migliorie e crediti",
        "make_a_decision": "Prendi una decisione",
        "marginOnBudget": "Margine sul budget (%)",
        "marginOnUpgrades": "Margine sulle migliorie (%)",
        "marginOnUpgradesExplainer": "Il margine sulle migliorie verrà utilizzato anche sui budget extra che assegna a un cliente. Il budget extra può essere impostato all'interno della decisione di un'unità.",
        "marginOverview": "Panoramica margini",
        "marginSubTitle": "Calcola automaticamente i margini in percentuale",
        "marginTitle": "Usa percentuali di margine",
        "members": "Membri",
        "modifyLater": "Può modificare queste impostazioni in seguito",
        "name": "Nome",
        "newActivity": "Nuovi aggiornamenti nella cronologia",
        "newDocument": "Nuovo/i documento/i",
        "next": "Avanti",
        "no": "No",
        "noApprovedProposalYet": "Nessuna proposta ancora accettata",
        "noBudget": "Nessun budget definito",
        "noCustomer": "Nessun cliente ancora",
        "noCustomerAssigned": "Nessun cliente ancora assegnato all'unità",
        "noDeadline": "Nessuna scadenza",
        "noDecisionDueDate": "Selezioni una scadenza",
        "noDecisionStartDate": "Nessuna data di inizio impostata",
        "noDecisionsMade": "Nessuna decisione ancora presa",
        "noDecisionsToMake": "Nessuna decisione da prendere.",
        "noDecisionsYet": "Nessuna decisione ancora",
        "noDocumentsShared": "Nessun documento condiviso",
        "noDueDate": "Imposti prima una scadenza prima di impostare i promemoria",
        "noDueDateSet": "Nessuna scadenza impostata",
        "noExtraBudget": "Nessun budget extra",
        "noMessages": "Scriva il Suo primo messaggio per {decision} nel campo sottostante",
        "noUnitDocuments": "Nessun documento ancora aggiunto alla cartella unità",
        "noUnitsClick": "Nessuna unità ancora, faccia clic qui per aggiungerne",
        "no_result_for_search": "Nessun risultato per questa ricerca filtrata.",
        "no_surcharges": "Nessuna miglioria",
        "no_surcharges_info": "Proposte senza migliorie finanziarie",
        "notDecided": "Non ancora deciso",
        "notDecidedYet": "Il cliente non ha ancora preso una decisione.",
        "notFollowing": "Non segue — faccia clic per ricevere notifiche",
        "notPossibleToWriteMessageDeactivatedUnit": "Questa decisione è collegata a un'unità disattivata. Non è più possibile scrivere un nuovo messaggio.",
        "notPublished": "Non pubblicata",
        "notPublishedCustomer": "Decisione non ancora pubblicata per il cliente",
        "notPublishedPartners": "Decisione non ancora pubblicata per i partner della decisione",
        "notShared": "Non condivisa",
        "not_interested": "Non interessato",
        "not_interested_customer": "Non interessato",
        "not_interested_customer_info": "Se non è interessato a questa decisione, o se questa decisione non è rilevante per Lei, faccia clic qui per indicarlo.",
        "not_interested_modal": {
          "customer": {
            "body": "Fornisca ulteriori dettagli sul motivo per cui non è interessato a questa decisione",
            "title": "Non sono interessato a questa decisione"
          },
          "employee": {
            "body": "Fornisca ulteriori dettagli sul motivo per cui il cliente non è interessato a questa decisione. Questo feedback sarà visibile anche al cliente.",
            "title": "Il cliente non è interessato a questa decisione"
          },
          "feedback": "Feedback"
        },
        "one": "1",
        "open": "Aperta",
        "openDecisionInfo": "Questa decisione è aperta. Il cliente può approvare le proposte.",
        "open_auto_close_deadline_unit": "Imposti se la decisione si chiuderà automaticamente o meno al superamento della scadenza",
        "open_auto_close_unit": "Imposti se la decisione si chiuderà automaticamente o meno all'approvazione ",
        "open_close_unit": "la decisione per 1 unità | la decisione per {unit_count} unità",
        "or": "o",
        "participants": "Partecipanti",
        "partners": "Partner della decisione",
        "pendingDecisions": "1 decisione da prendere | {count} decisioni da prendere",
        "priceBudget": "Budget",
        "priceBudgetExtra": "Budget extra",
        "proposal": "Proposte",
        "proposals": "Proposte | 1 proposta | {count} proposte",
        "publish?": "Salvare e pubblicare?",
        "publishNow?": "Pubblicare ora?",
        "publishTopOfPage": "Può pubblicare questa decisione nella parte superiore di questa pagina",
        "publishedCount": "Pubblica questa decisione per 1 unità | Pubblica la decisione per {count} unità",
        "publishedCustomer": "Decisione pubblicata per il cliente",
        "publishedCustomerPartners": "Decisione pubblicata per il cliente e i partner della decisione",
        "publishedNone": "Non ancora pubblicata",
        "publishedPartners": "Decisione pubblicata per i partner della decisione",
        "publishedSince": "Decisione pubblicata dal {date}",
        "published_info": "Mostra se tutte le unità sono state pubblicate per i clienti e/o i partner della decisione",
        "remainOpen": "Rimane aperta",
        "reminders": "Promemoria",
        "remindersCount": "1 promemoria | {count} promemoria",
        "reopenDecision": "Riapri decisione",
        "requiresDocumentVerification": "Richiede un documento firmato per l'approvazione",
        "requiresNoDocumentVerification": "Nessun documento firmato richiesto per l'approvazione",
        "returnToTickets": "Torna indietro",
        "rights": {
          "access_full": "Accesso completo",
          "access_full_info": "Può condividere messaggi, documenti e proposte direttamente con il cliente",
          "access_full_short": "Completo",
          "access_none": "Accesso limitato",
          "access_none_info": "Nessuna comunicazione con il cliente: solo per uso interno",
          "access_none_short": "Limitato",
          "access_semi": "Accesso di base",
          "access_semi_info": "Può inviare messaggi al cliente, ma non documenti o proposte",
          "access_semi_short": "Base",
          "customer_show": "Può visualizzare le informazioni del cliente.",
          "default": "I partner della decisione possono inviare messaggi, caricare documenti e creare proposte per <b>{client_name}</b> in qualsiasi momento. Hanno inoltre accesso alle planimetrie nella cartella documenti dell'unità. Di seguito può modificare i loro diritti di comunicazione verso i Suoi clienti.",
          "document_customer": "Può condividere i propri documenti direttamente con il cliente.",
          "message_customer": "Può inviare messaggi al cliente.",
          "proposal_customer": "Può condividere le proprie proposte direttamente con il cliente."
        },
        "save?": "Salvare?",
        "saveExplainer": "Rendere questa decisione visibile ai Suoi clienti? Oppure salvare e pubblicare più tardi?",
        "select": "Seleziona",
        "selectOneUnit": "Selezioni almeno 1 unità",
        "selectUnits": "Seleziona unità",
        "select_units": "Seleziona unità",
        "selected": "{selected} unità selezionata. | {selected} unità selezionate.",
        "sharedWith": "Condiviso con",
        "showDecisionsFor": "Mostra decisioni per",
        "show_all_units": "Mostra tutte le unità",
        "signOnline": "Digiti il nome per confermare (predefinito)",
        "signUploadDocument": "Carica documento firmato",
        "signedDocument": "Carica documento firmato",
        "status": "Stato",
        "statusExplained": "Cosa significa ogni stato della decisione?",
        "step2Subtitle": "Selezioni il Suo progetto per includere tutte le Sue unità in una volta sola.",
        "step2Title": "Quali unità devono prendere una decisione?",
        "step2TitleWithDecisionName": "Quali unità devono prendere una decisione per {decision_name}?",
        "subject": "Oggetto",
        "summary": "Riepilogo",
        "surcharge_tooltip": "Questa è la miglioria per questa decisione",
        "surcharges_total": "Migliorie: {total}",
        "surcharges_total_tooltip": "Questo è l'importo totale delle migliorie per tutte le unità che ne hanno una",
        "three": "3",
        "tickets": "Conversazioni",
        "toBeDecided": "Da decidere",
        "toDecide": "Da decidere",
        "total": "Totale",
        "totalSelected": "Tutte le {total} unità sono selezionate.",
        "true": "Sì",
        "two": "2",
        "type": "Tipo",
        "unitDecisionsWillBeShownHere": "Le decisioni dell'unità verranno mostrate qui",
        "unitNotActivated": "Solo per unità attivate",
        "unitSelected": "Nessuna unità | Un'unità | {count} unità",
        "unit_name": "Unità",
        "units": "Unità",
        "unpublish": "Non pubblicata",
        "unpublished": "Non pubblicata",
        "uploadDocument": "Carica documenti",
        "useMargins": "Attiva percentuali di margine",
        "use_surcharges": "Usa migliorie",
        "use_surcharges_info": "Imposta un budget per le migliorie",
        "validation_errors": "Ci sono dei problemi con questa proposta. Li risolva prima di riprovare.",
        "waitingForClient": "In attesa del cliente",
        "whatTheCustomerHasBought": "Cosa ha acquistato il cliente",
        "when": "Quando",
        "who": "Chi",
        "withAll": "Tutti",
        "withClient": "Solo con {client}",
        "withCustomer": "Con il cliente",
        "withCustomerName": "Con {customer}",
        "withPartners": "Solo con i partner della decisione",
        "yes": "Sì"
      },
      "legend": {
        "all": "Tutte le decisioni",
        "approved": "Deciso",
        "approvedAfterDue": "Proposta approvata dopo la scadenza",
        "created": "Nessuna proposta ancora",
        "decisionApproved": "Deciso",
        "hasDecision": "Nessuna proposta ancora",
        "hasProposal": "Proposta caricata",
        "has_proposal": "Da decidere",
        "isExpired": "Scadenza superata, nessuna proposta caricata",
        "isExpiredHasProposal": "Scadenza superata, proposta caricata",
        "noDecision": "Unità esclusa da questa decisione",
        "not_interested": "Non interessato",
        "other_decisions": "Altre decisioni",
        "requested_changes": "Modifiche richieste",
        "waiting_for_proposal": "In attesa della proposta"
      },
      "navigation": {
        "backToDecisions": "Torna alle decisioni"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Presto arriveranno nuove decisioni.",
            "title": "Si prepari a prendere una decisione"
          },
          "no_documents": {
            "subtitle": "Qui troverà tutti i documenti relativi a questa decisione",
            "title": "Carichi i documenti relativi alla decisione {decision_name}"
          }
        },
        "employees": {
          "conversations": {
            "none": {
              "subtitle": "Da quando un cliente sarà assegnato a questa unità, vedrà le conversazioni qui",
              "title": "Qui troverà tutte le conversazioni per questa decisione"
            }
          },
          "new": {
            "subtitle": "Assegni una decisione a più unità in un solo passaggio",
            "title": "Crei la Sua prima decisione"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Riceverà una notifica via email quando verrà pubblicata una nuova decisione.",
            "title": "Non ha ancora nessuna decisione"
          }
        }
      },
      "toasts": {
        "bulk_create": "Decisione creata con successo | Decisioni create con successo",
        "bulk_delete": "Decisione eliminata con successo | Decisioni eliminate con successo",
        "bulk_update": "Decisione aggiornata con successo | Decisioni aggiornate con successo",
        "update": "Decisione aggiornata con successo"
      },
      "validation": {
        "amountRequired": "Importo obbligatorio",
        "cannotUpdatePrice": "Il budget non può essere modificato poiché le rate basate su questa decisione sono state rese visibili al cliente",
        "customer": {
          "need_not_interested_note": "Indichi il motivo per cui non è interessato a questa decisione"
        },
        "employee": {
          "need_not_interested_note": "Indichi il motivo per cui il cliente non è interessato a questa decisione."
        },
        "installmentsSent": "Alcune decisioni selezionate hanno rate visibili per il cliente. Il loro budget rimarrà invariato.",
        "mustBeZeroOrMore": "Deve essere 0 o superiore",
        "needAttachment": "Carichi almeno un nuovo documento o ne selezioni uno dalla cartella dell'unità",
        "needNumber": "È necessario un numero (es. 8400,5)",
        "needTitle": "Titolo obbligatorio",
        "need_responsible": "È necessario un responsabile",
        "priceBudgetNotNegative": "Il budget non può essere un numero negativo.",
        "responsibleRequired": "Responsabile obbligatorio",
        "selectContactPerson": "Selezioni almeno 1 persona di contatto"
      }
    }
  }
}
